import { useQuery } from 'components/hooks/useQuery';

import { SURVEY_PRESETS } from './SurveyCreationPresets';

export const usePresetInitializationInfo = () => {
  const surveyPresetsList = SURVEY_PRESETS.filter((preset) => preset.type).map((preset) => preset.type);
  const { preset: queryParamPreset } = useQuery();
  const isPresetInitialization =
    !!queryParamPreset && surveyPresetsList.includes(queryParamPreset as unknown as string);

  return {
    isPresetInitialization,
    presetInfo: SURVEY_PRESETS.find((preset) => preset.type === queryParamPreset) ?? null,
  };
};
